export const registrationApiPath = {
  checkRegistration: '/v2/curator/check-registration',
} as const;
